import { render, staticRenderFns } from "./Listprofil.vue?vue&type=template&id=277bd6bc"
import script from "./Listprofil.vue?vue&type=script&lang=js"
export * from "./Listprofil.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports